export const blockIconsDeviceMonitorHeart = (
	<span className='material-symbols-outlined'>monitor_heart</span>
);
